import { GUF_PRIMITIVE_FIELD_SCHEMA_LIBRARY } from "./guf-schema-primitive-library";
import {
  designInstallationSchema,
  designLoopSchema,
  designScreenSchema,
  designSurfaceInfiltrationSchema,
  designWellSchema,
  licensedQuantitySchema,
  realisedLoopSchema,
  realisedScreenChangesSchema,
  realisedScreenSchema,
  realisedSurfaceInfiltrationSchema,
  realisedWellClosurePartSchema,
  realisedWellExpandedSchema,
  realisedWellSchema,
} from "./internal";

const GUF_FIELD_SCHEMA_LIBRARY = {
  ...GUF_PRIMITIVE_FIELD_SCHEMA_LIBRARY,
  designScreen: designScreenSchema,
  designWells: designWellSchema,
  designLoops: designLoopSchema,
  designSurfaceInfiltrations: designSurfaceInfiltrationSchema,
  licensedQuantities: licensedQuantitySchema,
  designInstallations: designInstallationSchema,
  realisedScreens: realisedScreenSchema,
  realisedWells: realisedWellSchema,
  realisedWellsExpanded: realisedWellExpandedSchema,
  realisedLoops: realisedLoopSchema,
  realisedSurfaceInfiltrations: realisedSurfaceInfiltrationSchema,
  realisedScreenChanges: realisedScreenChangesSchema,
  realisedWellsClosurePart: realisedWellClosurePartSchema,
};

type FieldSchemaLibraryType = typeof GUF_FIELD_SCHEMA_LIBRARY;

export function pickGufLibraryFields<K extends keyof FieldSchemaLibraryType>(
  fieldNames: readonly K[]
): Pick<FieldSchemaLibraryType, K> {
  const result = {} as Pick<FieldSchemaLibraryType, K>;
  for (const name of fieldNames) {
    result[name] = GUF_FIELD_SCHEMA_LIBRARY[name];
  }
  return result;
}
